 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","105":"pubnub","106":"srcdoc-polyfill","108":"vendors~polyfills","109":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"64a29198d3e86c72090a","2":"d2779da2fee62d425f73","3":"737b9d38862167ca8d98","4":"ababa28932de326600cb","5":"f585e6e92a3386e45178","6":"bc9d295dc4bd721220bd","7":"2cbf85f4aa65a304e467","8":"87b600a07a85b3437c23","9":"b914f8d8a20c78cfc715","10":"d7345929108aee86c269","11":"2d4c42d4e352841290fa","12":"346217a1dc46fe0d8f6b","13":"898bee8af4e598d77eb9","14":"af1ceea426687dcead46","15":"ee28c43f6a182d2a9fc9","16":"ba0625423c57edd52126","17":"053992e68e1dc1b44d8f","18":"969a7f434dcfbfbf307a","19":"448b10c6cc7c9dd51864","20":"9409dc4a9c81e22557dc","21":"85025afb2e53d8be360a","22":"cbb3207f414ca3729fd5","23":"4f1a391e6810dd6d69f1","24":"3c7ba72f869c8311efa2","25":"2f60c8ce098a70dd9537","26":"f6fe2ad4c382a38ccd7c","27":"0b233dcb56ec85b495c6","28":"c3de31f609ac88746906","29":"a7c8b59837b9c782a1ce","30":"4ee83ad3a09b8826901e","31":"91c825f7308ae84d2bb6","32":"60a858cb99197ce6cc52","33":"1290c8f150d1bea8dbbf","34":"870442bda53c3619b39e","35":"798d840114041a01d133","36":"eafdc17cd64441d1e818","37":"2191a0a9c018ceb26f19","38":"180e78d4332244a61bcf","39":"d400dc3de7e04c903dda","40":"f16c4ef786ea1abda1bf","41":"268f78dfd6e7798f87c3","42":"0452427505c6171c0fff","43":"e5ccd6900a08ad7c981f","44":"07ee92701c2b38e92696","45":"98d33197f98f35a7237a","46":"03ecca98943d039cde33","47":"3f9f6e3a44014269a5ac","48":"b463f7fa772a396db007","49":"940b38f3b29d0cb24ffa","50":"033dd292b1a512b6ca91","51":"0136bd88c2cd5d521d6c","52":"b6112e39bfb0118cf651","53":"48665a89cf7c8be954cf","54":"f3811b125df1e0195a80","55":"2848c5d720681170681b","56":"bc172cae3787e5ce1747","57":"4fd9e65f20be6db851f5","58":"2f57b20424577d4072ee","59":"39cda9e338e5349f04a4","60":"2aea6538244f933e5484","61":"b39ce9382d8fe3dc74b2","62":"880a9f1b1d660cd6abb3","63":"3159244939b20e328e3e","64":"2e2c8893a962b7d912cd","65":"66966da8a2fbe64b860b","66":"1470952576dea49b2a44","67":"f1f63b4474e07d12bc4d","68":"d09355f8e3dfc6247e4d","69":"be8280eae0d06477da66","70":"93cea93adf16755b467f","71":"16fdef8737f9ad651105","72":"b19705d0b48665637317","73":"d71b252268bd8e3270dd","74":"becc89ee83464abd1e38","75":"e40d93f28c9cc6c13636","76":"11d12a6d63eea904127a","77":"91af35f4552f17075636","78":"0c396c8b0e854d647389","79":"db159988e085e0099633","80":"db3d09e801996f638698","81":"f69709b096a8e1aa9e28","82":"9fe0259b968b72604949","83":"d40e5eab1d347848be48","84":"1641da3705b88642c5a6","85":"770ae2620f4e84a49e58","86":"36ff81f114478f494848","87":"a1ba10a2dffd479e4577","88":"a822f7f73ca8f8529ee0","89":"f76931dd1f0259104b8e","90":"1b9ffdf1e3c8c65346c3","91":"02ddcebce24df80cfe56","92":"bd175294a89c97f2dd5c","93":"c08a64b8d3a9f0e3a13b","94":"cd26a7b8019e58447cee","95":"c49406997e38042d4b0b","96":"dd2369baab39a4d35991","97":"3720877f58498b955c7a","98":"9240331f8a2fb15c59d0","99":"1b6e1cf943053c4e0d86","100":"16dc1e3217d2bc3c34dd","101":"7be4c5e9101ddebef6c4","102":"523a84a77024bcb2c2ef","103":"5b4b837c69056b841384","104":"3c4abb22520e0ca85b6b","105":"938f3b4ea2a7e15f355e","106":"3ba5e990bfd7af59ce51","108":"47af79874a1fef940ee7","109":"7a7ee4a464365e97bbb8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 83);
